<template>
  <div>
    <v-autocomplete
      v-model="selectedItem"
      :items="lista"
      :item-text="itemText"
      :item-value="itemValue"
      :placeholder="
        $t(
          `placeholders.${
            lista && lista.length > 0 ? 'autocomplete' : 'busca'
          }`,
          { campo: rotulo }
        )
      "
      :label="rotulo"
      
      :rules="rules"
      :clearable="clearable"
      :disable-lookup="disableLookup"
      :auto-select-first="autoSelectFirst"
      :prepend-inner-icon="prependInnerIcon"
      :filter="filter"
      hide-no-data
      @change="updateValue"
      @click="click"
      @keyup="updateSearch"
      @click:prepend-inner.prevent="$emit('icon-click', $event)"
      @focusin="$emit('focusin')"
      @focusout="$emit('focusout')"
      class="text-caption"
      persistent-hint
      persistent-placeholder
      return-object
      outlined
      :dark="dark"
      dense
      v-bind="$attrs"
    >
      <template v-slot:append-outer v-if="enableRegisterButton">
        <v-icon v-text="'mdi-plus'" @click="$emit('register-click')"> </v-icon>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    enableRegisterButton: {
      type: Boolean,
      default: false,
    },
    prependInnerIcon: {
      type: String,
      default: '',
    },
    itemValue: {
      type: String,
      default: 'CODIGO',
    },
    itemText: {
      type: String,
      default: 'DESCRICAO',
    },
    rotulo: {
      type: String,
      default: '',
    },
    lista: {
      type: Array,
      default: () => [],
    },
    item: {
      type: [Object, String, Number],
      default: () => {},
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disableLookup: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: true,
    },
    autoSelectFirst: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Function,
    },
  },
  computed: {
    selectedItem: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('update:item', val)
      },
    },
    rules() {
      const rules = []
      if (this.isRequired) {
        const rule = (value) =>
          !!value || this.$i18n.t('validation-messages.requiredField')
        rules.push(rule)
      }
      return rules
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    },
    updateSearch(value) {
      this.$emit('searchinput', value)
    },
    click(value) {
      this.$emit('click', value)
    },
  },
}
</script>

<style></style>
